import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import '../../App.css';

var WydrukMagazyn = React.createClass({

	getInitialState: function() {
		return {
			items: []
		}
    },

		renderOne: function(w, idx, total) {
			var pageBreak = idx < total - 1 ? { pageBreakAfter: 'always' } : {};
			return (
				<div key={w.id} className="wydruk-page" style={pageBreak}>
					<table>
					<tbody>
						<tr>
							<td colSpan="2"><h2 style={{textAlign:'left',margin:0}}>{w.punktSprzedazy}</h2></td>
							<td colSpan="2" style={{textAlign:'right'}}><h2 style={{margin:0}}><strong>Nr zam: {w.id}</strong></h2></td>
						</tr>
						<tr>
							<td>Data:</td><td>{w.dataZlozenia}</td>
							<td>Szkło:</td><td>{w.szklo}</td>
						</tr>
						<tr>
							<td>Imię i nazwisko:</td><td>{w.imie} {w.nazwisko}</td>
							<td>HDF:</td><td>{w.hdf ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td><strong>Telefon:</strong></td><td><strong>{w.telefon}</strong></td>
							<td>Zawieszka:</td><td>{w.zawieszka ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td>Data odbioru:</td><td>{w.dataOdbioru}</td>
							<td>Lustro:</td><td>{w.lustro ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td><strong>Numer listwy:</strong></td><td><strong>{w.numerListwy}</strong></td>
							<td>Passe partout:</td><td>{w.czyPass ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td>Numer passe partout:</td><td>{w.numerPass}</td>
							<td>Szlif:</td><td>{w.szlif ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td>Wysokość:</td><td>{w.wysokosc}</td>
							<td>Faza:</td><td>{w.faza ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td>Szerokość:</td><td>{w.szerokosc}</td>
							<td>Krosno:</td><td>{w.krosno ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							{w.iloscSztuk > 1 ? <td>Ilość sztuk:</td> : <td></td>}
							{w.iloscSztuk > 1 ? <td>{w.iloscSztuk}</td> : <td></td>}
							<td>Folia:</td><td>{w.folia ? 'TAK' : 'NIE'}</td>
						</tr>
						<tr>
							<td><strong>Uwagi:</strong></td>
							<td colSpan="3"><strong>{w.uwagi}</strong></td>
						</tr>
						<tr>
							<td>Sprzedawca:</td>
							<td colSpan="3">{w.operator}</td>
						</tr>
					</tbody>
					</table>
				</div>
			);
		},

		render: function() {
			var items = this.state.items;
			var total = items.length;
			var title = total > 1
				? 'Wydruk dla Magazynu - ' + total + ' zleceń'
				: 'Wydruk dla Magazynu - Zlecenie nr ' + (items[0] ? items[0].id : '');
			var self = this;
			return (
				<Modal show={this.props.parent.state.showWydrukMagazynModal} bsSize={total > 1 ? 'large' : null}>
					<Modal.Header>
						<Modal.Title>{title}</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
					<div id='printable'>
					<style>{'#printable .wydruk-page{margin-bottom:20px;}#printable table{width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:20px;color:#000;}#printable td{border:1px solid #000;padding:16px 18px;vertical-align:middle;}#printable h2{text-align:center;margin:10px 0;font-size:34px;}'}</style>
					{items.map(function(it, idx) { return self.renderOne(it, idx, total); })}
					</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeWydrukMagazynModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onDrukujBtnClicked}>Drukuj{total > 1 ? ' (' + total + ')' : ''}</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	buildItem: function(z) {
		return {
			id: z.id,
			cena: z.cena,
			czyZdjecie: z.czyZdjecie,
			grubosc: z.grubosc,
			hdf: z.hdf,
			kosztUslugi: z.kosztUslugi,
			lustro: z.lustro,
			numerListwy: z.numerListwy,
			numerPass: z.numerPass,
			operator: z.operator,
			punktSprzedazy: z.punktSprzedazy,
			szerokosc: z.szerokosc,
			szklo: z.szklo,
			uwagi: z.uwagi,
			wysokosc: z.wysokosc,
			zawieszka: z.zawieszka,
			dataZlozenia: z.dataZlozenia,
			imie: z.imie,
			nazwisko: z.nazwisko,
			telefon: z.telefon,
			pozostalaDoplata: z.pozostalaDoplata,
			dataOdbioru: z.dataOdbioru,
			czyPass: z.czyPass,
			szlif: z.szlif || false,
			faza: z.faza || false,
			krosno: z.krosno || false,
			folia: z.folia || false,
			iloscSztuk: z.iloscSztuk || 1,
		};
	},

	fillWydrukMagazynObject: function() {
		var self = this;
		var ids = this.props.parent.state.selectedZlecenieIds || [];
		var items = ids.map(function(id) {
			var z = self.props.parent.getZlecenieById(id);
			return z ? self.buildItem(z) : null;
		}).filter(function(it) { return it !== null; });
		this.setState({ items: items });
	},

	clearWydrukMagazynObject: function() {
		this.setState({ items: [] });
	},

	onDrukujBtnClicked: function() {
		var printContents = document.getElementById('printable').innerHTML;
		var win = window.open('', 'PRINT');
		win.document.write('<html><head><title>Wydruk magazyn</title>');
		win.document.write('<style>body{font-family:Arial,sans-serif;margin:16px;color:#000;}.wydruk-page{page-break-after:always;}.wydruk-page:last-child{page-break-after:auto;}table{width:100%;border-collapse:collapse;font-size:20px;page-break-inside:avoid;}td{border:1px solid #000;padding:16px 18px;vertical-align:middle;}h2{text-align:center;margin:10px 0;font-size:34px;}</style>');
		win.document.write('</head><body>');
		win.document.write(printContents);
		win.document.write('</body></html>');
		win.document.close();
		win.focus();
		win.print();
		win.close();
		this.props.parent.closeWydrukMagazynModal();
	}

});

export default WydrukMagazyn;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/WydrukMagazyn.js